import {
  PlatformSettingsService,
  GetClientOnboardingSegmentOptions,
  SegmentOnboarding,
  SegmentSetting,
} from '@simpleinvest/ms-platform-settings-sdk';
// eslint-disable-next-line import/no-cycle
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';

export default {
  getPlatformSettingsServiceInstance(): PlatformSettingsService {
    return new PlatformSettingsService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger: getLogger(),
    });
  },

  async getPlatformSettings(clUserId: string): Promise<SegmentSetting[]> {
    const service: PlatformSettingsService = this.getPlatformSettingsServiceInstance();

    const result = await service.getAllPlatformSettingsForClient({clUserId});

    return result?.segmentSettings || [];
  },
  async getClientOnboardingSegment(options: GetClientOnboardingSegmentOptions): Promise<SegmentOnboarding> {
    const service: PlatformSettingsService = this.getPlatformSettingsServiceInstance();

    const result = await service.getClientOnboardingSegment({segmentId: options.segmentId, riaId: options.riaId});

    return result;
  },
};
